const galleryApi=[
  {
    id:1,
    name:'Tasty Burger',
    img:"images/g-1.jpg",
    description:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, ipsum.",
},
{
  id:2,
  name:'Tasty Pizza',
  img:"images/g-2.jpg",
  description:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, ipsum.",
},
{
  id:3,
  name:'Cold Ic Cream',
  img:"images/g-3.jpg",
  description:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, ipsum. ",
},
{
  id:4,
  name:'Cold Drinks',
  img:"images/g-4.jpg",
  description:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, ipsum.",
},
{
  id:5,
  name:'Tasty Sweets',
  img:"images/g-5.jpg",
  description:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, ipsum.",
},
{
  id:6,
  name:'Healty breakfast',
  img:"images/g-6.jpg",
  description:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, ipsum.",
},
{
  id:7,
  name:'Tasty Food',
  img:"images/g-7.jpg",
  description:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, ipsum.",
},
{
  id:8,
  name:'Tasty Food',
  img:"images/g-8.jpg",
  description:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, ipsum.",
},
{
  id:9,
  name:'Tasty Food',
  img:"images/g-9.jpg",
  description:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deleniti, ipsum.",
},


]

export default galleryApi;